module.exports = __webpack_public_path__ + "img/microflavours_small.32210298.svg";